/**
 * 주어진 수에 천단위 쉼표를 추가한다.
 * @see https://stackoverflow.com/a/2901298
 * @param num
 * @example
 * numberForamt(12000); // 12,000
 * numberFormat(1050.3644); // 1,050.3644
 */
export function numberFormat(num: string | number = 0): string {
  if (Number.isNaN(Number(num))) {
    return '0';
  }

  const parts = num.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
}

/**
 * 한자리 수 일 경우 앞에 '0'을 추가한다.
 *
 * @param num
 * @example
 * makeTwoDigitString('2'); // '02'
 * makeTwoDigitString(1); // '01'
 */
export function makeTwoDigitString(num: string | number = 0): string {
  if (Number.isNaN(Number(num))) {
    return '0';
  }

  return num.toString().padStart(2, '0');
}
